import { HttpStatusCode } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { AppError, ToastService, ToastType } from '@hglobal/fin-ui';
import { catchError, OperatorFunction } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StoreHelperService {
  readonly #toast = inject(ToastService);

  readonly handleError = this.#handleError.bind(this);

  showToast(toastType: ToastType, messageKey: string, titleKey?: string): void {
    this.#toast.show({ type: toastType, message: messageKey, title: titleKey });
  }

  catchError<T>(): OperatorFunction<T, T> {
    return catchError((error: AppError) => {
      this.handleError(error);
      throw error;
    });
  }

  #handleError(error: AppError): void {
    if (
      error?.originalError?.status !== HttpStatusCode.NotFound &&
      error?.originalError?.status !== HttpStatusCode.Unauthorized
    ) {
      //TODO: Add error handling logic here
    }
  }
}
